import { createSelector } from '@reduxjs/toolkit'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitAttentionSearch = createSelector(
  selectFinancialCockpitState,
  ({ attentionSearch }) => attentionSearch
)
